import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class StaffingAnalysisDTO  {
    _originalTypeClassName = "zERP.BO.StaffingAnalysisDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
StaffingAnalysisDTO.translate = translateService;
}
this.Id = null;
this.DepPosTitle = null;
this.DepPositionType = null;
this.WorkPosition = null;
this.Technology = null;
this.Status = null;
this.EmployeeCode = null;
this.ReplacementFullname = null;
this.PositionFilledDate = null;
this.ContractStartDate = null;
this.RelationshipType = null;
this.Salary = null;
this.Levels = null;
this.StaffingAnalysisDTOKey = null;
this._key = this.StaffingAnalysisDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
DepPosTitle:any;
DepPositionType:any;
WorkPosition:any;
Technology:any;
Status:any;
EmployeeCode:any;
ReplacementFullname:any;
PositionFilledDate:any;
ContractStartDate:any;
RelationshipType:any;
Salary:any;
Levels:any;
private _StaffingAnalysisDTOKey:any;
get StaffingAnalysisDTOKey(): any {
    return this._StaffingAnalysisDTOKey;
  }
set StaffingAnalysisDTOKey(value: any) {
    this._StaffingAnalysisDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.StaffingAnalysisDTOKey == null || $this.StaffingAnalysisDTOKey == 0;
            }


}